import React from "react";
function Footer() {
  return (
    <footer className="container  fixed bottom-0 bg-white dark:bg-dark-mode">
      <p className="text-xs text-center text-dark-content mx-auto py-1 md:left-20 dark:text-light-content w-full">
        Designed and Coded by Ritu with
        <span className="text-gradient font-medium"> Love</span> &
        <span className="text-gradient font-medium"> Lays</span>
      </p>
    </footer>
  );
}
export default Footer;
